import { Injectable, NgZone } from '@angular/core'
import { APIService } from 'api/module'
import { SocketService } from 'common/util/services/socket.service'
import { SubclipClipboardEntry, SubclipReference, MediaFileBundleMiniReference } from 'elements-sdk'
import { BehaviorSubject, merge } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class SubclipsClipboardService {
  loading: boolean
  items: SubclipClipboardEntry[]
  items$ = new BehaviorSubject<SubclipClipboardEntry[]>([])

  constructor (
    private api: APIService,
    private socket: SocketService,
    zone: NgZone,
  ) {
    this.items = []
    merge(
      socket.subject('media:subclip-clipboard-entry-created'),
      socket.subject('media:subclip-clipboard-entry-deleted'),
    ).subscribe(() => zone.run(() => this.reload()))
    this.reload()
  }

  private setItems (items: SubclipClipboardEntry[]): void {
    this.items = items
    this.items$.next(items)
  }

  async reload (): Promise<void> {
    this.loading = true
    this.setItems(await this.api.mediaLibrary.getAllSubclipClipboardEntries({}))
    this.loading = false
  }

  async add (cut: SubclipReference, bundle: MediaFileBundleMiniReference): Promise<void> {
    if (!this.items.some(x => x.cut.id === cut.id)) {
      const subclip = await this.api.mediaLibrary.createSubclipClipboardEntry({
        subclipClipboardEntryUpdate: { cut, bundle },
      })
      this.setItems([...this.items, subclip])
    }
  }

  async remove (subclip: SubclipReference): Promise<void> {
    await this.api.mediaLibrary.deleteSubclipClipboardEntry(subclip)
    this.setItems(this.items.filter(x => x.id !== subclip.id))
  }

  async clear (): Promise<void> {
    await this.api.mediaLibrary.clearSubclipClipboard()
    this.setItems([])
  }
}
